import {
  Box,
  Button,
  Container,
  Grid,
  Hidden,
  Link,
  Typography,
} from "@mui/material";
import React from "react";
import {
  BCPArrowLeft,
  BCPCircleStar,
} from "../../components/icons/bcp/BCPIcons";

export default function OrganizeCircuits(props) {
  const { appMode, circuits, loading } = props;

  return (
    <Box sx={{ width: "100%" }}>
      <Container sx={{ pt: 2, pb: 2 }} maxWidth="lg">
        <Grid container sx={{ gap: 2, p: 2 }}>
          <Grid item xs={12}>
            <Link
              href="/organize/dashboard"
              color="link.main"
              sx={{
                textDecoration: "none",
                display: "flex",
                alignItems: "center",
                justifyContent: "flex-start",
              }}
            >
              <BCPArrowLeft
                sx={{ "padding-right": "1rem", "padding-bottom": "2px" }}
              />{" "}
              Back to Host Dashboard
            </Link>
          </Grid>

          <Grid
            item
            xs={12}
            sx={{
              display: { xs: "block", md: "flex" },
              justifyContent: "space-between",
            }}
          >
            <Grid container spacing={2}>
              <Grid item xs={12} md={9}>
                <Typography
                  variant="h2"
                  component="h3"
                  fontWeight="700"
                  gutterBottom
                >
                  My Circuits
                </Typography>
              </Grid>

              <Hidden mdDown>
                {!(!loading && !circuits?.length) && (
                  <Grid item xs={12} md={3}>
                    <Button
                      variant="contained"
                      href="/organize/circuit"
                      target={`${appMode ? "_blank" : "_self"}`}
                      startIcon={<BCPCircleStar />}
                      fullWidth
                    >
                      Create Circuit
                    </Button>
                  </Grid>
                )}
              </Hidden>
            </Grid>
          </Grid>
        </Grid>
      </Container>
    </Box>
  );
}
